export default "https://cdn-static.gokick.com/assets/bd7d2df9c3fbba7be4a416b625ad3f88793f3763/images/sleep-bottles.21ff427124b73aa7b2cf5884e65ef589.jpg";